module.exports = "/_next/static/images/img__hand-29b7e55fb59523be215733eca791f324.png";